export default class PlayersDashboardNotFoundError extends Error {}
